/* istanbul ignore file */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useFormContext } from 'framework/form';
import OpportunitiesBreadcrumbs from 'domain/sales/opportunity/shared/OpportunitiesBreadcrumbs';
import { SingleBreadcrumbItem, UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const UpdateOpportunityBreadcrumbs = () => {
  const { id } = useParams<Dictionary<string>>();
  const { data = {} } = useFormContext();
  const { name } = data;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const displayedName = useMemo(() => name, []);

  return (
    <OpportunitiesBreadcrumbs>
      <SingleBreadcrumbItem entity={displayedName} link={`/crm/opportunities/${id}`} />
      <UpdateBreadcrumbItem />
    </OpportunitiesBreadcrumbs>
  );
};

export default UpdateOpportunityBreadcrumbs;
